export enum DisneyNameMealPLan {
  DISNEY_DINING_PLAN = 'Disney Dining Plan',
  QUICK_SERVICE_DINING_PLAN = 'Quick-Service Dining Plan',
  TABLE_SERVICE_DINING_PLAN = 'Table-Service Dining Plan',
  DELUXE_TABLE_SERVICE_DINING_PLAN = 'Deluxe Table-Service Dining Plan',
  ROOM_ONLY = 'room only',
  ROOM_ONLY_UPPERCASE = 'ROOM_ONLY',
}
